import React from 'react';
import { Row, Col } from 'antd';
import { DEPLOYMENT_ENVIRONMENT } from '../constants/index';
import { Space, Typography } from 'antd';
import {
    ArrowRightOutlined
  } from '@ant-design/icons';

const { Text, Link } = Typography;


function Introduction(props) {
    const example1 = require('../examples/example_01.json');

    let internallink;
    if (DEPLOYMENT_ENVIRONMENT == 'internal') {
        internallink =   <li><a href="/compassinternal">ReDoc Internal Full API spec</a> <ArrowRightOutlined /> This is the technical specification for each of the endpoints</li>;
    } 

    return (
        <Row>
            <Col xs={1} xl={4}>

            </Col>
            <Col xs={22} xl={16}>

                <h1>Introduction to Compass API</h1>

                <p>Welcome to the compass API documentation. This set of online resources will 
                    guide you through the use of the Compass API to query for content and data 
                    from your provider. </p>

                <p>The Guide has the following sections</p>
                <div className="sectionlist">
                <ol>
                    <li><a href="/">Start here</a> <ArrowRightOutlined /> This introduction</li>
                    <li><a href="/access">Accessing the API</a> <ArrowRightOutlined /> A guide to access the API and successfully make your first call</li>
                    <li><a href="/compass">ReDoc API spec</a> <ArrowRightOutlined /> This is the technical specification for each of the endpoints</li>
                    {internallink}
                    <li><a href="/searchexamples">Search Basics</a> <ArrowRightOutlined /> An introduction and set of examples for search</li>
                    <li><a href="/search">Search Fields</a> <ArrowRightOutlined /> A list of standard fields you can use within the search</li>
                </ol>
                </div>

                <p>You can access each section by clicking the menu in the top rights of this help guide.</p>

            </Col>
            <Col xs={1} xl={4}>

            </Col>
        </Row>
    )
}
export default Introduction;